module.exports = __webpack_public_path__ + "static/media/invite_guests.bb34e73a.svg";